<template>
  <div>
    <div class="panel">
      <div class="label">标题：</div>
      <div class="value3">渠道备案申请_{{ extra.belongProvince }}{{ extra.belongCity }}{{ extra.district }}_{{ extra.deptName }}</div>
      <div class="label">主要负责人：</div>
      <div class="value1">{{ extra.chargeUserName }}</div>
      <div class="label">所属部门：</div>
      <div class="value2">{{ extra.deptName }}</div>
      <div class="label">客户名称：</div>
      <div class="value3">{{ extra.customerName }}</div>
      <div class="label">业务类型：</div>
      <div class="value1">{{ extra.businessType }}</div>
      <div class="label">所属地市：</div>
      <div class="value2">{{ extra.belongProvince }}{{ extra.belongCity }}{{ extra.district }}</div>
      <div class="label">所属区域：</div>
      <div class="value1">{{ extra.areaName }}-{{ extra.subAreaName }}-{{ extra.l3AreaName }}</div>
      <div class="label">经营属性：</div>
      <div class="value2">{{ extra.businessProperty }}</div>
      <div class="label">是否专属区域：</div>
      <div class="value1">{{extra.isExclusiveArea}}</div>
      <div class="label">客户业态：</div>
      <div class="value2">{{ extra.profession }}</div>
      <div class="label">一级细分：</div>
      <div class="value1">{{ extra.firstSubdivision }}</div>
      <div class="label">客户关系：</div>
      <div class="value2">{{ extra.customerRelationship }}</div>
      <div class="label">企业性质：</div>
      <div class="value1">{{ extra.customerNature }}</div>
      <div class="label">联系人姓名：</div>
      <div class="value2">{{ JSON.parse(extra.contactJson).name }}</div>
      <div class="label">联系人部门：</div>
      <div class="value1">{{ JSON.parse(extra.contactJson).apartment }}</div>
      <div class="label">联系人职务：</div>
      <div class="value2">{{ JSON.parse(extra.contactJson).position }}</div>
      <div class="label">联系人手机：</div>
      <div class="value1">{{ JSON.parse(extra.contactJson).mobile }}</div>
      <div class="label">业务决策人：</div>
      <div class="value2">{{ JSON.parse(extra.contactJson).isDecisionMaker?'是':'否' }}</div>
      <div class="label">互访带队领导：</div>
      <div class="value1">{{ extra.visitLeaderName }}</div>
      <div class="label">互访日期：</div>
      <div class="value2">{{ dateFormatter(extra.visitDate) }}</div>
      <div class="label">潜在项目线索说明：</div>
      <div class="value3">{{ extra.remark }}</div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { getName } from "@/utils/clock";
import moment from "moment";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return this.detail.extra
        ? {
          ...this.detail.extra,
        }
        : {};
    },
  },
  methods: {
    getName,
    dateFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    renderStaff(str) {
      let msg = "";
      try {
        const list = JSON.parse(str);
        msg = list.map((item) => item.userName).join("，");
      } catch (error) {
        msg = str;
      }

      return msg;
    },
  },
};
</script>


<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  &>div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>